export class Gca {
    numRUCPuntoPartida: string;
    numRUCPuntoLlegada: string;
    codEstabPuntoPartida: string;
    codEstabPuntoLlegada: string;
    fechaEntregaBienesAlTranportista: Date;
    numContenedor1: string;
    numPrecinto1: string;
    numContenedor2: string;
    numPrecinto2: string;
    numeroRegistroMTC: string;

    constructor(numRUCPuntoPartida?: string,
                numRUCPuntoLlegada?: string,
                codEstabPuntoPartida: string = '0000',
                codEstabPuntoLlegada: string = '0000',
                numeroRegistroMTC?: string,
                fechaEntregaBienesAlTranportista?: Date,
                numContenedor1?: string,
                numPrecinto1?: string,
                numContenedor2?: string,
                numPrecinto2?: string
    ) {
        this.numRUCPuntoPartida = numRUCPuntoPartida;
        this.numRUCPuntoLlegada = numRUCPuntoLlegada;
        this.codEstabPuntoPartida = codEstabPuntoPartida;
        this.codEstabPuntoLlegada = codEstabPuntoLlegada;
        this.numeroRegistroMTC = numeroRegistroMTC;
        this.fechaEntregaBienesAlTranportista = fechaEntregaBienesAlTranportista;
        this.numContenedor1 = numContenedor1;
        this.numPrecinto1 = numPrecinto1;
        this.numContenedor2 = numContenedor2;
        this.numPrecinto2 = numPrecinto2;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/gca.ts